import * as momentNs from 'moment';
// tslint:disable-next-line:typedef
const moment = momentNs;
/**
 * Created by vgellerman on 2/17/2017.
 */

export class ReferenceData {
  id: string;
  correlationId: { correlation: string };
  code: string;
  description: string;
  shortDescription: string;
  effectiveFrom: momentNs.Moment;
  effectiveUntil: momentNs.Moment;
  version: number;
  revisionId: string;
  deleted: boolean;
  createdDate: momentNs.Moment;
  createdBy: string;
  lastModifiedDate: momentNs.Moment;
  lastModifiedBy: string;

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    this.id = data.id;
    this.correlationId = data.correlationId;
    this.code = data.code;
    this.description = data.description;
    this.shortDescription = data.shortDescription;
    this.effectiveFrom = moment(data.effectiveFrom, 'YYYY-MM-DD');

    if (data.effectiveUntil) {
      this.effectiveUntil = moment(data.effectiveUntil, 'YYYY-MM-DD');
    }
    this.version = data.version;
    this.revisionId = data.revisionId;
    this.deleted = data.deleted || false;
    this.createdDate = moment(data.createdDate, 'YYYY-MM-DD');
    this.createdBy = data.createdBy;
    this.lastModifiedDate = data.lastModifiedDate;

    if (data.lastModifiedDate) {
      this.lastModifiedDate = moment(data.lastModifiedDate, 'YYYY-MM-DD');
    }

    this.lastModifiedBy = data.lastModifiedBy;
  }

  get modified(): boolean {
    return this.lastModifiedBy != undefined || this.lastModifiedDate != undefined;
  }

  get label(): string {
    return this.description;
  }

  get value(): { correlation: string } {
    return this.correlationId;
  }
}
